/** Service Desk console: tracker broadcast, split, similar tickets, translate, knowledge drafts, capacity caps, read receipts and the weekly summary (SD-S4-04 / 05 / 08). */
export const serviceExtras = {
  tracker: {
    title: "Tracker",
    notTracker: "Hindi ito tracker ticket.",
    notTrackerHint: "Sinusubaybayan ng tracker ang iisang sanhi - isang outage, isang recall - sa maraming ticket ng kliyente. Gawing tracker type ang ticket para makapagpadala ng isang update sa lahat.",
    linkedTitle: "Mga naka-link na ticket",
    linkedNone: "Wala pang naka-link na ticket sa tracker na ito. I-link ang ticket ng kliyente bilang \"caused by\" at lalabas ito rito.",
    customer: "Kliyente",
    internalOnly: "Internal",
    hidden: "{{count}} naka-link na ticket na hindi mo mabubuksan ang hindi nakalista.",
    limit: "Hanggang {{max}} ticket lang ang ina-update ng tracker nang sabay.",
    composerLabel: "Update para sa mga naka-link na ticket",
    composerPlaceholder: "Ano ang nagbago? Nasa lugar na ang crew, bumalik na ang serbisyo...",
    publicLabel: "Public note",
    publicHint: "Naka-on: mababasa ito ng kliyente ng bawat ticket bilang sagot. Naka-off: internal note ito sa bawat ticket.",
    send: "Ipadala ang update",
    confirmTitle: "Magpadala ng public update sa {{count}} ticket?",
    confirmBody: "Babasahin ito ng bawat kliyente bilang sagot ng inyong team. Hindi na ito mababawi.",
    confirmSend: "Ipadala sa {{count}} ticket",
    sentPublic: "Naipadala ang public update sa {{count}} ticket",
    sentInternal: "Nadagdagan ng internal note ang {{count}} ticket",
    skipped: "{{count}} ticket ang nilaktawan.",
    skip: {
      no_access: "Hindi ka maaaring sumulat dito",
      closed: "Sarado na ito",
      not_customer: "Hindi ticket ng kliyente",
      failed: "Hindi ito na-update",
    },
    error: "Hindi na-load ang tracker. Subukan muli.",
    retry: "Subukan muli",
    empty: "Isulat muna ang update.",
  },
  split: {
    title: "Hatiin",
    intro: "Kopyahin ang ilang mensahe sa bagong ticket para sa parehong kliyente. Buo pa rin ang usapan sa orihinal.",
    open: "Hatiin ang mga mensahe sa bagong ticket",
    dialogTitle: "Hatiin sa bagong ticket",
    dialogBody: "Piliin ang mga mensaheng kokopyahin. Pareho ang requester at organisasyon ng bagong ticket at naka-link ito sa {{number}}.",
    titleLabel: "Pamagat ng bagong ticket",
    titleHint: "Iwanang walang laman para gamitin ang \"{{title}} (split)\".",
    choose: "Mga mensaheng kokopyahin",
    internalNote: "Internal note",
    selected: "{{count}} mensahe ang napili",
    pickOne: "Pumili ng kahit isang mensahe.",
    submit: "Gumawa ng ticket",
    done: "Nagawa ang {{number}} na may {{count}} mensahe",
    noMessages: "Wala pang mensaheng mahahati.",
    error: "Hindi nahati ang ticket.",
    view: "Buksan ang {{number}}",
  },
  seen: {
    label: "Nakita {{when}}",
    aria: "Binuksan ng kliyente ang sagot na ito noong {{when}}",
  },
  copilot: {
    title: "AI assist",
    off: "Naka-off ang staff AI sa workspace na ito.",
    noCredits: "Kulang ang credits para sa staff AI.",
    unavailable: "Hindi sumagot ang AI model. Walang siningil.",
    retry: "Subukan muli",
    similar: {
      title: "Mga katulad na nalutas na ticket",
      intro: "Ang ginawa noong huli. Una ang organisasyon ng kliyente, saka ang iba pa sa workspace. Libre.",
      find: "Maghanap ng katulad na ticket",
      finding: "Naghahanap",
      noneTitle: "Wala pang katulad",
      none: "Wala pang katulad na nalutas na ticket. Lalabas dito ang mga ticket na nalutas na may malinaw na tala.",
      again: "Maghanap muli",
      organisation: "Parehong organisasyon",
      workspace: "Ibang organisasyon",
      noNote: "Walang resolution note.",
      match: "{{percent}}% magkatulad",
      error: "Hindi na-load ang mga katulad na ticket.",
      graph: {
        badge: "Niranggo gamit ang mga kaugnay na tala",
        hint: "Bilang din ang kagamitan, produkto, link at organisasyon, hindi lang ang mga salita.",
      },
      why: {
        label: "Bakit magkatulad",
        more: "{{count}} pang dahilan",
        same_asset: "Parehong kagamitan",
        same_product: "Parehong produkto",
        linked: "Naka-link na ticket",
        merged: "Pinagsama",
        shared_problem: "Parehong naka-link na problema",
        same_organisation: "Parehong organisasyon",
        same_site: "Parehong lugar",
        same_requester: "Parehong humiling",
        same_category: "Parehong kategorya",
        shared_tags: "Parehong tag ({{count}})",
        same_resolution: "Parehong resolusyon",
        same_sla_breach: "Parehong paglabag sa SLA",
        has_article: "May artikulo sa knowledge",
      },
    },
    translate: {
      action: "Isalin",
      toFil: "Sa Filipino",
      toEn: "Sa English",
      working: "Isinasalin",
      original: "Orihinal",
      result: "Salin sa {{language}}",
      languageFil: "Filipino",
      languageEn: "English",
      copy: "Gamitin sa sagot",
      copied: "Naidagdag sa iyong reply box",
      close: "Itago ang salin",
      note: "Ikaw lang ang makakakita. Hindi ito kusang ipinapadala. 1 credit.",
      error: "Hindi gumana ang pagsasalin.",
    },
    draft: {
      title: "Knowledge article",
      intro: "Gawing artikulo ang nakalutas sa ticket na ito. Draft muna ito hanggang aprubahan mo; naka-mask ang mga personal na detalye.",
      create: "Gumawa ng draft na artikulo mula sa ticket",
      creating: "Gumagawa ng draft",
      openExists: "May draft na ang ticket na ito sa ibaba. I-approve o i-discard muna ito bago gumawa ng bago.",
      costs: "1 credit.",
      notResolved: "I-resolve ang ticket na may resolution note para makagawa ng artikulo mula rito.",
      none: "Wala pang draft.",
      status: { draft: "Draft", approved: "Aprubado", discarded: "Itinapon" },
      edit: "I-edit",
      save: "I-save ang pagbabago",
      approve: "Aprubahan at idagdag sa knowledge",
      approveTitle: "Idagdag ang artikulong ito sa inyong knowledge?",
      approveBody: "Magiging knowledge source ito na team ninyo lang ang makakabasa hangga't hindi mo binabago kung sino ang makakakita.",
      approved: "Naidagdag sa inyong knowledge",
      openSource: "Buksan sa Knowledge",
      discard: "Itapon",
      discarded: "Itinapon ang draft",
      titleLabel: "Pamagat",
      bodyLabel: "Artikulo",
      created: "Handa nang suriin ang draft",
      error: "Hindi nagawa ang draft.",
      needKnowledge: "Kailangan mo rin ng pahintulot na gumawa ng knowledge para maaprubahan ito.",
      removed: "{{count}} pahayag na hindi suportado ng ticket ang inalis.",
    },
  },
  transcript: {
    download: "I-download ang PDF",
    failed: "Hindi na-download ang PDF. Subukan muli.",
  },
  fieldAssist: {
    intro: "Gawing maikling buod na mababasa ng kliyente ang iyong mga naka-save na tala. Hintayin muna ang Saved; ang naka-save ang ginagamit ng buod.",
    run: "Sumulat ng buod na madaling basahin ng kliyente",
    failed: "Hindi naisulat ang buod. Walang siningil; subukan muli.",
    result: "Buod para sa kliyente (i-edit bago gamitin)",
    use: "Gamitin sa report",
    discard: "Itapon",
    note: "1 credit. Suriin ang bawat pangungusap: hindi ito kusang ipinapadala.",
  },
  capacity: {
    title: "Capacity caps",
    intro: "Ang pinakamaraming bukas na ticket na kusang ibibigay sa isang tao. Lalaktawan ng routing rules ang nasa cap na; maaari pa rin siyang i-assign nang mano-mano ng manager.",
    member: "Miyembro",
    cap: "Cap",
    holding: "{{count}} bukas ngayon",
    atCapacity: "Puno na",
    placeholder: "Walang cap",
    save: "I-save",
    saved: "Na-save ang capacity ni {{name}}",
    invalid: "Gumamit ng buong numero mula {{min}} hanggang {{max}}, o iwanang walang laman para walang cap.",
    empty: "Wala pang aktibong miyembro.",
    error: "Hindi na-load ang capacity.",
    retry: "Subukan muli",
    atCapacityNote: "Puno na ang lahat ng makakakuha nito, kaya maghihintay ito sa queue.",
  },
  switches: {
    title: "Read receipts at mga summary",
    receiptsTitle: "Ipakita ang \"Nakita\" ng kliyente sa mga sagot ng staff",
    receiptsHint: "Kapag naka-on, makikita mo kung kailan unang binuksan ng kliyente ang sagot sa portal o sa widget. Naka-off bilang default.",
    receiptsPrivacy: "Privacy: ang oras lang ng unang pagbubukas ang iniimbak. Walang itinatala para sa internal notes o sa mga kliyenteng nagbabasa sa email.",
    receiptsSaved: "Ang read receipts ay {{state}} na",
    on: "naka-on",
    off: "naka-off",
    summaryTitle: "Lingguhang Service summary sa email",
    summaryHint: "Tuwing Lunes, ang mga numero ng nakaraang linggo - mga ticket na binuksan at nalutas, bukas ngayon, rating - at ang mga numero ng pinakamatatandang bukas na ticket. Walang detalye ng kliyente.",
    summaryNotEligible: "Kailangan mo ng pahintulot na makakita ng reports para matanggap ang summary.",
    summarySaved: "Ang lingguhang summary ay {{state}} na para sa iyo",
    error: "Hindi na-save ang mga setting na ito.",
    loading: "Naglo-load",
  },
}
